function RightWordListArea(props: any) {
  let myProps = {
    select_info_arr: props.select_info_arr,
    ...props
  };
  let select_info_arr = myProps.select_info_arr;
  let select_info = null;
  if (select_info_arr.length > 0) {
    select_info = select_info_arr[0];
  }
  let cg_word_arr: any = [];
  if (select_info && select_info.cg_word_arr) {
    cg_word_arr = select_info.cg_word_arr;
  }

  return (
    <div className="list-table-div">
      <table>
        <colgroup>
          <col width={"30px"}></col>
          <col width={"250px"}></col>
          <col width={"250px"}></col>
        </colgroup>
        <tbody>
          {cg_word_arr.map((word_info: any, idx: number) => {
            return (
              <tr key={idx}>
                <td className='text-center'>{idx + 1}</td>
                <td>{word_info["a_word"]}</td>
                <td>{word_info["a_mean"]}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
export default RightWordListArea;